import * as React from 'react';
import {Icon} from 'tt-components/src/Icon/Icon';
import {Tt2b} from '../../../../components/Typography/Tt2b';

import {ChevronDownIcon} from '../../../../assets/Icons/ChevronDownIcon';
import {ChevronRightIcon} from '../../../../assets/Icons/ChevronRight';
import {wait} from '../../../../utils/utils';
import {withEditModeToggle} from '../../hoc/withEditModeToggle';

export interface ICollapsibleProps {
  title?: JSX.Element | string;
  content?: JSX.Element | string;
  open?: boolean;
  initOpenState?: boolean;
  blockTriggerOnSelectores?: Array<string>;
  onToggle?: (state: boolean) => void;
  className?: string;
}

interface ICollapsibleState {
  open: boolean;
  transitClass: string;
  isVisible: boolean;
}

export class Collapsible extends React.PureComponent<ICollapsibleProps, ICollapsibleState> {
  static defaultProps = {
    blockTriggerOnSelectores: [],
    initOpenState: false
  };
  static getDerivedStateFromProps(nextProps: ICollapsibleProps, prevState: ICollapsibleState) {
    if (nextProps.open !== prevState.open && typeof nextProps.open !== 'undefined') {
      return {open: nextProps.open};
    }
    return null;
  }

  constructor(props: ICollapsibleProps) {
    super(props);

    this.state = {
      open: props.initOpenState,
      transitClass: '',
      isVisible: false
    };
  }

  componentDidMount() {
    this.setState({transitClass: this.state.open ? 'hidden' : ''}, this.transitOnInit);
  }

  transitOnInit = async () => {
    await wait(50);
    this.setState({transitClass: 'hidden', isVisible: true});
  };

  onToggle = (e: React.MouseEvent<HTMLDivElement>) => {
    if (
      this.props.blockTriggerOnSelectores.length &&
      !!(e.target as HTMLElement).closest(this.props.blockTriggerOnSelectores.join(','))
    ) {
      return;
    }
    if (typeof this.props.open !== 'undefined' && this.props.onToggle) {
      this.props.onToggle(!this.state.open);
    } else {
      this.setState({open: !this.state.open});
    }
  };

  getContent = () => (
    <div className={`collapsible-container_content${this.state.open ? `` : ` ${this.state.transitClass}`}`}>
      {this.props.content || 'Some content'}
    </div>
  );

  getHeaderComponent = () => {
    if (!this.props.title || typeof this.props.title === 'string') {
      return <Tt2b content={this.props.title || ''} className="collapsible-container_header_text" />;
    }
    return this.props.title;
  };

  render() {
    const className = this.props.className ? ` ${this.props.className}` : ``;
    const visible = this.state.isVisible ? ` visible` : ``;
    return (
      <div className={`collapsible-container${className}${visible}`}>
        <div className={`collapsible-container_header${this.state.open ? ` open` : ``}`} onClick={this.onToggle}>
          {this.getHeaderComponent()}
          <div className="collapsible-container_header_icon">
            <Icon icon={this.state.open ? ChevronDownIcon : ChevronRightIcon} color="#8194B5" size="14px" />
          </div>
        </div>
        {this.getContent()}
      </div>
    );
  }
}

export const CollapisbleWithEditModeToggle = withEditModeToggle(Collapsible);
